// Choose contrast from the composited footer background, including theme changes.
export function watchFooterContrast(element) {
  const footer = element.closest('footer');
  if (!footer) return () => {};
  function update() {
    let rgb = [0, 0, 0], opacity = 0;
    for (let node = footer; node && opacity < 0.999; node = node.parentElement) {
      const values = getComputedStyle(node).backgroundColor.match(/[\d.]+/g);
      if (!values || values.length < 3) continue;
      const alpha = values.length > 3 ? Number(values[3]) : 1;
      rgb = rgb.map((value, index) => value + Number(values[index]) * alpha * (1 - opacity));
      opacity += alpha * (1 - opacity);
    }
    rgb = rgb.map(value => value + 255 * (1 - opacity));
    const linear = rgb.map(value => { const s = value / 255; return s <= 0.04045 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4; });
    const luminance = linear[0] * 0.2126 + linear[1] * 0.7152 + linear[2] * 0.0722;
    element.style.setProperty('--dgroup-ink', luminance > 0.179 ? '#000' : '#fff');
  }
  const observer = new MutationObserver(records => {
    if (records.some(record => record.target.contains(footer))) update();
  });
  observer.observe(document.documentElement, {attributes:true,subtree:true,attributeFilter:['class','style','data-theme','data-bu-theme']});
  const scheme = window.matchMedia('(prefers-color-scheme: dark)');
  scheme.addEventListener('change', update);
  footer.addEventListener('transitionend', update);
  update();
  return () => { observer.disconnect(); scheme.removeEventListener('change', update); footer.removeEventListener('transitionend', update); };
}
